import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  galleryWrapper: {
    height: '284px',
    [theme.breakpoints.down('md')]: {
      height: '238px',
    },

    '& + div': {
      margin: '16px 0 12px 0',
    },
  },
  planImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
}));
